import { PortalTextCommonImport } from '../../Models/Api/strongbox.financialportal';
import { AppCookieData } from '../../Models/CookieData';
import { GetAccountingPackageDefinitions } from '../../Services/Tenant';
import { LogException } from '../../Utils/Logging';
import {
    AppThunkActionAsync
} from '../index';
import { KnownAction as uiKnownActions, actionCreators as uiStateActions } from '../UIState';
import {
    AppSettingsActions,
    IAddAccountingPackageToBlacklist,
    IInitAppSettingsAction,
    IOverrideSettings,
    ISetAccountingGroupText,
    ISetAccountingPackage,
    ISetAccountingPackageBlacklist,
    ISetShowDeletedSubmissions,
    KnownAction,
} from './Actions';
import { IAppSettingsState } from './Reducer';


function Initalize(appData: AppCookieData): IInitAppSettingsAction {
    return {
        type: AppSettingsActions.Initialize,
        appData: appData,
    };
}

function SetShowDeletedSubmissions(showDeletedSubmissions: boolean): ISetShowDeletedSubmissions {
    return {
        type: AppSettingsActions.SetShowDeletedSubmissions,
        show: showDeletedSubmissions,
    };
}

function OverrideAppSettings(overrideState: Partial<IAppSettingsState>): IOverrideSettings {
    return {
        type: AppSettingsActions.OverrideSettings,
        overrideState,
    };
}

function SetAccountingPackage(accountingPackage: string, on: boolean): ISetAccountingPackage {
    return {
        type: AppSettingsActions.SetAccountingPackage,
        package: accountingPackage,
        on,
    };
}

function SetAccountingPackageBlacklist(blacklist: string, include: boolean): ISetAccountingPackageBlacklist {
    return {
        type: AppSettingsActions.SetAccountingPackageBlacklist,
        include,
        blacklist,
    };
}

function AddAccountingPackageToBlacklist(pkg: string): IAddAccountingPackageToBlacklist {
    return {
        type: AppSettingsActions.AddAccountingPackageToBlacklist,
        pkg,
    };
}

function SetAccountingGroupText(commonImportText: PortalTextCommonImport): ISetAccountingGroupText {
    return {
        type: AppSettingsActions.SetAccountingGroupText,
        commonImportText,
    };
}

const LoadAccountingPackageDefinitions = (): AppThunkActionAsync<void, KnownAction | uiKnownActions> =>
    async (dispatch, getState): Promise<void> => {
        const workingName = `GetDataCollectionLimit`;

        dispatch(uiStateActions.SetPortalWorking(workingName));

        try {
            const definitions = await GetAccountingPackageDefinitions();
            dispatch({
                type: AppSettingsActions.LoadAccountingPackageDefinitionsComplete,
                accountingPackageDefinitions: definitions,
            });
        } catch (ex) {
            const errorMsg = 'Failure retrieving accounting package definitions';

            console.error(errorMsg);
            console.error(ex);

            LogException(errorMsg, ex);
        } finally {
            dispatch(uiStateActions.SetPortalIdle(workingName));
        }
    }

export const actionCreators = {
    AddAccountingPackageToBlacklist: AddAccountingPackageToBlacklist,
    Initialize: Initalize,
    SetShowDeletedSubmissions,
    OverrideAppSettings,
    SetAccountingPackage,
    SetAccountingPackageBlacklist,
    SetAccountingGroupText,
    LoadAccountingPackageDefinitions,
};
